import { FaNodeJs } from "react-icons/fa";
import { SiExpress, SiMongodb } from "react-icons/si";
import { FaVuejs } from "react-icons/fa6";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { SiNestjs } from "react-icons/si";
import { SiPostgresql } from "react-icons/si";
import { FaReact } from "react-icons/fa";
import { TbBrandTypescript } from "react-icons/tb";

import { project1 } from "./images";
import { project2 } from "./images";
import { project3 } from "./images";
import { project4 } from "./images";
import { project5 } from "./images";

export const menu = [
  { name: "Про мене", category: "About" },
  { name: "Послуги", category: "Services" },
  // { name: "Проєкти", category: "Projects" },
  { name: "Контакти", category: "Contact" },
];

export const projects = [
  {
    id: 1,
    title: "ENGL",
    image: project2,
    category: "Web",
    data: {
      description: `Платформа для вивчення слів, з підтримкою 256 мов. Вивчення слів проходить через флешкартки та безліч ігор.`,
      // demoLink: "https://engl-mk1h.onrender.com",
    },
    stack: [
      {
        name: "NodeJs",
        icon: <FaNodeJs />,
        iconColor: "green",
      },
      {
        name: "ExpressJs",
        icon: <SiExpress />,
      },
      {
        name: "MongoDB",
        icon: <SiMongodb />,
        iconColor: "limegreen",
      },
    ],
  },
  {
    id: 2,
    title: "VEIL",
    image: project4,
    category: "Web",
    data: {
      description: `Платформа, яка допомагає знайти не просто викладача, а наставника, який допоможе покращити рівень своїх знань.`,
      // demoLink: "https://veil-q3heeeujs-hremilys-projects.vercel.app",
    },
    stack: [
      {
        name: "Nest",
        icon: <SiNestjs />,
        iconColor: "red",
      },
      {
        name: "TS",
        icon: <TbBrandTypescript />,
        iconColor: "blue",
      },
      {
        name: "React",
        icon: <FaReact />,
      },
      {
        name: "Postgre",
        icon: <SiPostgresql />,
        iconColor: "darkblue",
      },
    ],
  },
  {
    id: 3,
    title: "CLINVIX",
    image: project5,
    category: "Web",
    data: {
      description: `Сайт для управління лікарнею: забезпечує зручне керування записами пацієнтів, графіками лікарів та швидкий доступ до медичних послуг.`,
      // demoLink: "",
    },
    stack: [
      {
        name: "TS",
        icon: <TbBrandTypescript />,
        iconColor: "blue",
      },
      {
        name: "React",
        icon: <FaReact />,
      },
      {
        name: "ExpressJs",
        icon: <SiExpress />,
      },
      {
        name: "Posrgre",
        icon: <SiPostgresql />,
        iconColor: "darkblue",
      },
    ],
  },

  {
    id: 5,
    title: "BALLERINE",
    image: project1,
    category: "Web",
    data: {
      description:
        "Сайт інтернет-магазину спідньої білизни, що пропонує стильні, комфортні та якісні моделі для будь-якого смаку.",
      // demoLink: "https://google.com/",
    },
    stack: [
      {
        name: "NodeJs",
        icon: <FaNodeJs />,
        iconColor: "green",
      },
      {
        name: "ExpressJs",
        icon: <SiExpress />,
      },
      {
        name: "MongoDB",
        icon: <SiMongodb />,
        iconColor: "limegreen",
      },
    ],
  },

  {
    id: 4,
    title: "ETOILE",
    image: project3,
    category: "Web",
    data: {
      description:
        "Сайт готелю з можливістю онлайн-бронювання номерів. Інформація про номери, зручності, ціни та фото. ",
      // demoLink: "https://shop-s5cj.onrender.com",
    },
    stack: [
      {
        name: "Nest",
        icon: <SiNestjs />,
        iconColor: "red",
      },
      {
        name: "TS",
        icon: <TbBrandTypescript />,
        iconColor: "blue",
      },
      {
        name: "Vue JS",
        icon: <FaVuejs />,
      },
      {
        name: "Posrgre",
        icon: <SiPostgresql />,
        iconColor: "darkblue",
      },
    ],
  },
];

export const experience = [
  {
    data: [
      {
        skill: "HTML",
        level: "Experienced",
      },
      {
        skill: "CSS",
        level: "Experienced",
      },
      {
        skill: "JavaScript",
        level: "Experienced",
      },
      {
        skill: "TypeScript",
        level: "Experienced",
      },
    ],
  },
  {
    data: [
      {
        skill: "Node JS",
        level: "Experienced",
      },
      {
        skill: "MongoDB",
        level: "Experienced",
      },
      {
        skill: "Express JS",
        level: "Experienced",
      },
      {
        skill: "Nest JS",
        level: "Experienced",
      },
      {
        skill: "MySQL",
        level: "Intermediate",
      },
      {
        skill: "PostgreSQL",
        level: "Experienced",
      },
      {
        skill: "Graphql",
        level: "Intermediate",
      },
    ],
  },
];

export const socialHandles = [
  // {
  //   name: "Telegram",
  //   icon: <FaTelegram />,
  //   link: "https://t.me/millunchik",
  // },
  {
    name: "Github",
    icon: <AiFillGithub />,
    link: "https://github.com/milunchik",
  },
  {
    name: "LinkedIn",
    icon: <AiFillLinkedin />,
    link: "https://www.linkedin.com/in/emilia-grab/",
  },
  // {
  //   name: "Instagram",
  //   icon: <FaInstagram />,
  //   link: "https://www.instagram.com/ab_emily_/",
  // },
];
